import { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { createStore } from "../../store/actions/AuthActions";
import ReCAPTCHA from 'react-google-recaptcha';
import { Modal } from "react-bootstrap";
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

function Register(props) {
	const [dataForm, setDataForm] = useState({
		name: "",
		phone: "",
		taxId: "",
		birthDate: "",
		username: "",
		password: "",
		email: "email@email.com",
		images: [],
		address: {
			number: "",
			street: "",
			city: "",
			state: "",
			zipcode: "",
			neighborhood: ""
		},
		captcha: ""
	});

	const [formattedValues, setFormattedValues] = useState({
		phone: "",
		taxId: "",
		zipcode: ""
	});

	const [recaptchaToken, setRecaptchaToken] = useState(null);
	const [showAddressFields, setShowAddressFields] = useState(false);

	const formatPhone = (value) => {
		const numbers = value.replace(/\D/g, "");
		let formatted = numbers;
		if (numbers.length <= 11) {
			formatted = numbers.replace(/^(\d{2})(\d{5})(\d{4}).*/, "($1) $2-$3");
		}
		return formatted;
	};

	const formatCNPJ = (value) => {
		const numbers = value.replace(/\D/g, "");
		return numbers.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}).*/, "$1.$2.$3/$4-$5");
	};

	const handlePhoneChange = (e) => {
		const { value } = e.target;
		const formattedPhone = formatPhone(value);
		setFormattedValues({ ...formattedValues, phone: formattedPhone });

		let cleanNumber = value.replace(/\D/g, "");

		if (cleanNumber.length > 2) {
			const ddd = cleanNumber.substring(0, 2);
			const rest = cleanNumber.substring(2);
			if (rest.startsWith('9')) {
				cleanNumber = ddd + rest.substring(1);
			}
		}

		const phoneForPayload = cleanNumber.length > 0 ? `55${cleanNumber}` : "";
		setDataForm({ ...dataForm, phone: phoneForPayload });
	};

	const handleCNPJChange = (e) => {
		const { value } = e.target;
		const formattedCNPJ = formatCNPJ(value);
		setFormattedValues({ ...formattedValues, taxId: formattedCNPJ });

		const cleanNumber = value.replace(/\D/g, "");
		setDataForm({ ...dataForm, taxId: cleanNumber });
	};

	const sendCreateStore = async () => {
		try {
			const formattedData = formatData(dataForm);
			const response = await createStore(formattedData);

			if (response.status === 200) {
				alert("Cadastro realizado com sucesso!");
			} else {
				alert("Erro ao realizar cadastro. Tente novamente.");
			}
		} catch (error) {
			console.error("Error creating store:", error);
		}
	};

	const formatData = (formData) => {
		return {
			...formData,
			address: {
				...formData.address,
				country: "Brasil"
			}
		};
	};

	const onRecaptchaChange = (token) => {
		setRecaptchaToken(token);
		setDataForm({ ...dataForm, ['captcha']: token });
	};

	const handleChange = (e) => {
		const { name, value } = e.target;

		setDataForm({
			...dataForm,
			[name]: value,
			...(name === "phone" && { username: value, password: value }),
		});
	};

	const MapAddress = ({ lat, lng, onMove }) => {
		useMapEvents({
			moveend: (e) => {
				const center = e.target.getCenter();
				onMove(center); // devolve lat/lng atualizados
			}
		});

		return (
			<>
				<Marker position={[lat, lng]} />
			</>
		);
	}

	const AddressMap = ({ lat, lng, onUpdate }) => {
		return (
			<MapContainer center={[lat, lng]} zoom={16} style={{ height: 250, width: '100%' }}>
				<TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
				<MapAddress lat={lat} lng={lng} onMove={onUpdate} />
			</MapContainer>
		);
	}

	useEffect(() => {
		if (dataForm.phone) {
			setDataForm((prev) => ({
				...prev,
				username: prev.phone,
				password: prev.phone,
			}));
		}
	}, [dataForm.phone]);

	return (
		<div id="register-user-ctn" className="authincation">
			<div id="background-client-register" >
			</div>
			<div className="container" >
				<div className="row justify-content-center">
					<div className="col-md-12 mr-auto ml-auto" style={{ maxWidth: 700 }}>
						<div className="card" style={{ backgroundColor: 'white' }}>
							<div className="card-header">
								<h3 className="text-center">Cadastro de Loja</h3>
							</div>
							<div className="card-body">
								<form onSubmit={(e) => e.preventDefault()}>
									<div className="mb-3">
										<h4>Dados Básicos</h4>
										<div className="row">
											<div className="col-md-6 mb-2">
												<label className="form-label">Nome da Loja</label>
												<input
													type="text"
													className="form-control"
													name="name"
													value={dataForm.name}
													onChange={handleChange}
													required
												/>
											</div>
											<div className="col-md-6 mb-2">
												<label className="form-label">Telefone</label>
												<input
													type="text"
													className="form-control"
													name="phone"
													value={formattedValues.phone}
													onChange={handlePhoneChange}
													maxLength={15}
													placeholder="(00) 00000-0000"
													required
												/>
											</div>
										</div>
									</div>

									<div className="mb-3">
										<div className="row">
											<div className="col-md-6 mb-2">
												<label className="form-label">CNPJ</label>
												<input
													type="text"
													className="form-control"
													name="taxId"
													value={formattedValues.taxId}
													onChange={handleCNPJChange}
													maxLength={18}
													placeholder="00.000.000/0000-00"
													required
												/>
											</div>
										</div>
									</div>

									{/* <div className="mb-3" style={{display: "none"}}>
										<h4>Dados de Acesso</h4>
										<div className="row">
											<div className="col-md-6 mb-2">
												<label className="form-label">Usuário</label>
												<input
													type="text"
													className="form-control"
													name="username"
													value={formattedValues.phone}
													onChange={handleChange}
													maxLength={15}
													required
												/>
											</div>
											<div className="col-md-6 mb-2">
												<label className="form-label">Senha</label>
												<input
													type="text"
													className="form-control"
													name="password"
													value={formattedValues.phone}
													onChange={handleChange}
													maxLength={15}
													required
												/>
											</div>
											<>
												<label className="form-label">Email</label>
												<input
													type="email"
													className="form-control"
													name="email"
													value={dataForm.email}
													placeholder="exemplo@email.com"
													required
												/>
											</>
										</div>
									</div> */}

									<div className="mb-3">
										<div className="row">
											<h4>Endereço</h4>
											<AddressAutocompleteOSM
												onSelectAddress={(addr) => {
													setDataForm({
														...dataForm,
														address: {
															...dataForm.address,
															...addr
														}
													});
													setShowAddressFields(true);
												}}
											/>
										</div>
										{showAddressFields && (
											<div className="row">
												<div className="col-md-12 mt-2 mb-3" style={{ display: 'flex' }}>
													<hr className="mb-3 mt-3" style={{ width: 'Calc(50% - 15px)' }} />
													<div className="w-100 text-center pt-2"><b>confirmar endereço</b></div>
													<hr className="mb-3 mt-3" style={{ width: 'Calc(50% - 15px)' }} />

												</div>
												<div className="col-md-12 mt-2 mb-3">
													<AddressMap
														lat={parseFloat(dataForm.address.latitude)}
														lng={parseFloat(dataForm.address.longitude)}
														onUpdate={(pos) => {
															setDataForm({
																...dataForm,
																address: {
																	...dataForm.address,
																	latitude: pos.lat,
																	longitude: pos.lng,
																},
															});
														}}
													/>
												</div>
												<div className="col-md-6 mb-2">
													<label className="form-label">Rua</label>
													<div
														style={{ backgroundColor: "rgb(233 233 233)", width: '100%', border: 0, borderRadius: 3 }}
														className="py-3 px-1 text-center"
														name="street"
													>
														{dataForm.address.street}
													</div>
												</div>
												<div className="col-md-6 mb-2">
													<label className="form-label">Número</label>
													<div
														style={{ backgroundColor: "rgb(233 233 233)", width: '100%', border: 0, borderRadius: 3 }}
														className="py-3 px-1 text-center"
														name="number"
													>
														{dataForm.address.number}
													</div>
												</div>
												<div className="col-md-6 mb-2">
													<label className="form-label">Bairro</label>
													<div
														style={{ backgroundColor: "rgb(233 233 233)", width: '100%', border: 0, borderRadius: 3 }}
														className="py-3 px-1 text-center"
														name="neighborhood"
													>
														{dataForm.address.neighborhood}
													</div>
												</div>
												<div className="col-md-6 mb-2">
													<label className="form-label">Cidade</label>
													<div
														style={{ backgroundColor: "rgb(233 233 233)", width: '100%', border: 0, borderRadius: 3 }}
														className="py-3 px-1 text-center"
														name="city"
													>
														{dataForm.address.city}
													</div>
												</div>
												<div className="col-md-6 mb-2">
													<label className="form-label">Estado</label>
													<div
														style={{ backgroundColor: "rgb(233 233 233)", width: '100%', border: 0, borderRadius: 3 }}
														className="py-3 px-1 text-center"
														name="state"
													>
														{dataForm.address.state}
													</div>
												</div>
												<div className="col-md-6 mb-2">
													<label className="form-label">CEP</label>
													<div
														style={{ backgroundColor: "rgb(233 233 233)", width: '100%', border: 0, borderRadius: 3 }}
														className="py-3 px-1 text-center"
														name="zipcode"
													>
														{dataForm.address.zipcode}
													</div>
												</div>
											</div>
										)}
									</div>

									{/* <div className="mb-3 d-flex justify-content-center">
										<ReCAPTCHA
											sitekey={"6LdLwaQqAAAAAL4Ktttukdp8qXT5pcHHd4PFbtOS"}
											onChange={onRecaptchaChange}
										/>
									</div> */}

									<div className="text-center">
										<button
											type="button"
											className="btn btn-primary"
											//disabled={!recaptchaToken}
											onClick={() => sendCreateStore()}
										>
											Cadastrar Loja
										</button>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

const AddressAutocompleteOSM = ({ onSelectAddress }) => {
	const [query, setQuery] = useState("");
	const [suggestions, setSuggestions] = useState([]);
	const [loading, setLoading] = useState(false);
	const [showModal, setShowModal] = useState(false);

	const extractNumberFromQuery = (input) => {
		// Regex para pegar primeiro número no input
		const match = input.match(/\b\d+\b/);
		return match ? match[0] : "";
	};

	const removeNumberFromQuery = (input, number) => {
		if (!number) return input;
		// Remove apenas a primeira ocorrência do número
		return input.replace(number, "").replace(/\s{2,}/g, " ").trim();
	};

	const searchAddress = async () => {
		if (!query || query.length < 3) {
			setSuggestions([]);
			return;
		}
		setLoading(true);
		const number = extractNumberFromQuery(query);
		const queryWithoutNumber = removeNumberFromQuery(query, number);

		try {
			const response = await fetch(
				`https://bot.pskeromais.com.br/api/street-founder?q=${encodeURIComponent(
					queryWithoutNumber
				)}`
			);
			const data = await response.json();
			setSuggestions(Array.isArray(data) ? data : []);
			// abre o modal com os resultados
			setShowModal(true);
		} catch (error) {
			console.error("Erro ao buscar endereço OSM:", error);
			setSuggestions([]);
			setShowModal(true); // abre modal mesmo que vazio (pode exibir "Nenhum endereço")
		} finally {
			setLoading(false);
		}
	};

	const formatAddress = (item, number = "") => {
		const addr = item.address || {};
		return [
			[addr.road, number || addr.house_number].filter(Boolean).join(", "), // rua + número
			addr.suburb, // bairro
			addr.city || addr.town || addr.village, // cidade
			addr.state, // estado
			addr.postcode, // CEP
			addr.country, // país
		]
			.filter(Boolean)
			.join(", ");
	};

	const handleSelect = (item) => {
		const number = extractNumberFromQuery(query); // pega o número que o usuário digitou
		const formatted = formatAddress(item, number);
		setQuery(formatted);
		setSuggestions([]);

		const { address, lat, lon } = item;
		const payload = {
			number: number || address.house_number || "",
			street: address.road || "",
			city: address.city || address.town || address.village || "",
			state: address.state || "",
			zipcode: address.postcode || "",
			neighborhood: address.suburb || "",
			country: 'Brasil',
			latitude: lat,
			longitude: lon,
		};

		onSelectAddress(payload);
	};

	return (
		<div style={{ position: "relative" }}>
			<div style={{ display: "flex", gap: 6 }}>
				<input
					type="text"
					className="form-control"
					placeholder="Digite seu endereço"
					value={query}
					onChange={(e) => setQuery(e.target.value)}
				/>
				<button
					type="button"
					className="btn btn-outline-secondary"
					onClick={searchAddress}
					disabled={query.length < 3 || loading}
					title="Buscar endereço"
				>
					<i className="bi bi-search" />
				</button>
			</div>

			{loading && <div style={{ marginTop: 6, fontSize: 16, margin: "13px 0" }}><div class="spinner-border text-primary" role="status">
				<span class="visually-hidden"></span>
			</div> Procurando endereço...</div>
			}

			{/* Modal — estilo e botão de fechar seguem seu padrão */}
			<Modal show={showModal} onHide={() => setShowModal(false)} centered>
				<button
					onClick={() => setShowModal(false)}
					className="btn btn-light p-1"
					style={{
						width: 30,
						height: 30,
						position: "absolute",
						right: 6,
						top: 6,
						borderRadius: "100%",
						zIndex: 1051,
					}}
				>
					<i className="bi bi-x-circle" style={{ fontSize: 14 }}></i>
				</button>

				<div
					className="d-flex align-items-center justify-content-center flex-column p-4"
					style={{ minHeight: 200 }}
				>
					<h4 style={{ borderBottom: "1px solid #f1f1f1", paddingBottom: 7 }}>
						<i className="fa-solid fa-location-dot"></i> Endereços encontrados
					</h4>
					<br />
					<div style={{ width: "100%" }}>
						{loading ? (
							<p>Carregando...</p>
						) : suggestions.length > 0 ? (
							<ul
								className="list-group"
								style={{ maxHeight: 300, overflowY: "auto" }}
							>
								{suggestions.map((item) => (
									<li
										key={item.place_id}
										className="list-group-item list-group-item-action"
										style={{
											cursor: "pointer",
											backgroundColor: "#fff",
											display: "flex",
											gap: 8,
											alignItems: "center",
										}}
										onClick={() => (handleSelect(item) , setShowModal(false))}
									>
										<i className="bi bi-geo-alt" style={{ fontSize: 18 }} />
										<div style={{ lineHeight: 1.1 }}>
											{formatAddress(item, extractNumberFromQuery(query))}
										</div>
									</li>
								))}
							</ul>
						) : (
							<p>Nenhum endereço encontrado.</p>
						)}
					</div>
				</div>
			</Modal>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		errorMessage: state.auth.errorMessage,
		successMessage: state.auth.successMessage,
		showLoading: state.auth.showLoading,
	};
};

export default connect(mapStateToProps)(Register);
